import(/* webpackMode: "eager" */ "/app/app/profile/page.tsx");
